import React, {useState, useEffect, useContext} from "react";
import AdminListPage from '../administration/components/AdminListPage';
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";


export default function AdministrationResourceRevisions(){
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	return (
		<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
			<AdminListPage
					title="Resource Revisions"
					headerTitle="Name"
					headerDescription="Description"
					restUrl="administration/list/resourcerevisions"
					adminPage="administration/edit/resourcerevision"
					downloadUrl=""
					uploadUrl=""
				/>
		</div>
	);
}